// Página «Editor del sitio» (shell Orion → /m/orion/editor-sitio; clásico → /m/site/editor).
// El agente del panel es el chat interno real (ChatPane) acotado a las tools del
// sitio (focus_tools="site_config"): solo PROPONE; publicar es de la persona admin.

import { ChatPane } from '@/components/assistant/ChatPane';
import { useModules } from '@/context/ModulesContext';
import { Globe } from 'lucide-react';
import { EmptyState } from '@/modules/orion-shell/ui';
import { SiteEditor } from './SiteEditor';

export function SiteEditorPage({ webChatHeaders, variant = 'shell' }: { webChatHeaders: Record<string, string>; variant?: 'shell' | 'classic' }) {
  const { isAdmin, isDev, availableModules } = useModules();
  // Solo orgs con sitio (módulo `site` ← site_config); el backend igual filtra por org.
  if (!availableModules.some((m) => m.key === 'site')) {
    return (
      <div className="mx-auto max-w-md p-6">
        <EmptyState icon={<Globe size={18} />} title="Tu organización aún no tiene sitio web">
          Cuando tu sitio esté activo podrás editarlo aquí con vista previa en vivo.
        </EmptyState>
      </div>
    );
  }
  return (
    <SiteEditor
      isAdmin={isAdmin || isDev}
      height={variant === 'shell' ? 'calc(100dvh - 64px)' : 'calc(100dvh - 150px)'}
      brandButton={variant === 'shell'}
      renderAgent={({ page, pageName, selected, onTurnDone, chatKey }) => (
        <ChatPane
          key={`site-editor-${chatKey}`}
          startFresh
          webChatHeaders={webChatHeaders}
          focusTools="site_config"
          hideThinking
          onTurnDone={onTurnDone}
          messagePrefix={`[Editor del sitio · página ${pageName} (page_slug "${page}")${selected ? ` · sección ${selected}` : ''}. Usa las herramientas del sitio para PROPONER el cambio (queda pendiente y se ve en la vista previa); no lo publiques.]`}
          emptyTitle="Pídele cambios a tu sitio"
          emptySubtitle="El agente propone; la propuesta aparece al instante en la vista previa y tú decides si se publica."
          suggestions={[
            selected ? `Mejora el texto de esta sección (${selected}) para que sea más claro` : 'Cámbiale el título de la portada a algo más directo',
            'Agrega una pregunta frecuente sobre precios',
            'Cambia el botón principal para que diga «Agenda una demo»',
          ]}
        />
      )}
    />
  );
}

export default SiteEditorPage;
